export const REFERRAL_ID_KEY = 'referralId'
